module.exports = __webpack_public_path__ + "static/media/surtidor-gris.0d4016e9.svg";